import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../amlaunderingDataSlice";
import getAntiLaunderingDataApi from "../api/getAntiLaunderingData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.antiLaundering;

  const pagedTrades = await dispatch(getAntiLaunderingDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
